module.exports = __webpack_public_path__ + "img/social4.36d9238c.png";